import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { getTypographyCss, theme } from '@revenuemarket/design';

import { InputProps } from './Input';

export const Wrapper = styled.div<Pick<InputProps, 'hasError'>>`
  display: flex;
  width: 100%;
  position: relative;
  background: ${theme.colors.grayscale700};
  border-radius: 4px;
  border: 1px solid transparent;
  height: 40px;
  ${({ hasError }) =>
    hasError &&
    css`
      border-color: ${theme.semanticColors.danger.regular};
    `}
`;

export const Input = styled.input<Pick<InputProps, 'hasError' | 'inlineCss'>>`
  width: 100%;
  height: 40px;
  background: none;
  padding: 0 12px;
  box-sizing: border-box;
  border: 0;
  outline: 0;
  color: ${theme.colors.grayscaleWhite};
  border-radius: 4px;

  &[disabled] {
    color: ${theme.colors.grayscale600};
    cursor: not-allowed;

    &::placeholder {
      color: ${theme.colors.grayscale600};
    }
  }

  ${getTypographyCss('body1')};

  ${({ inlineCss }) => inlineCss};
`;
